exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bold[data-v-b08eb200] {\n  font-weight: bold;\n}\n.clickable[data-v-b08eb200]:hover {\n  cursor: pointer;\n}\n.drag-drop-image[data-v-b08eb200] {\n  background-color: darkgray;\n  border: dashed 5px lime;\n  position: fixed;\n  display: block;\n  padding: 2rem;\n  top: calc(5vh + 65px);\n  left: 5vw;\n  width: 90vw;\n  height: calc(90vh - 64px);\n  z-index: 10;\n}\n.close-button[data-v-b08eb200] {\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 10;\n}", ""]);

// exports
